import { useBCMSModal, useModel, useParams, useRoute } from "@bcm-dev/bcms-vite";
import FormContainer, { FormButtonContainer, FormRow } from "components/shared/containers/FormContainer";
import { UICancelButton, UIPrimaryButton } from "components/ui/UIButton";
import React from "react";

import UIDatePicker from "components/ui/UIDatePicker ";
import UIRadio from "components/ui/UIRadio";
import { Card } from "model";
import { useState } from "react";
import { SVGAsset } from "res";
import "./styles.css";

/**
 * @function ReportView
 * @param cardType - This is the type of card (Debit/Credit)
 * @param lastFour - The last four numbers of the card
 * @return {React.Component}
 * @exported true
 * @description The main component for ReportView
 * @example
 * <ReportView cardType="Debit" lastFour=""x7890 />
 */
export default function ReportView(props) {
  const { branding } = useModel();
  const navigate = useRoute();
  const { open: openModal } = useBCMSModal();

  const defaultCard = branding.options.include_debit_chw23 !== "false" ? "0" : "1";
  const cardID = useParams().cardID ?? defaultCard;
  const card = Card.initByID(cardID);

  const cardType = card.type ?? "[Card Type]";
  const lastFour = card.lastFour ?? "XXXX";

  const [ reason, setReason ] = useState("Card is stolen");
  const changeReason = (value, label) => setReason(label);

  const debitBranding = branding.options.loststolen_debit_chw23;
  const creditBranding = branding.options.loststolen_credit_chw23;
  // Values that the debit and credit branding options support
  const lostStolenOptions = {
    withIssuance: "self-service with digital issuance",
    withoutIssuance: "self-service without digital issuance",
    directToCall: "direct to call",
    directToCallButAsk: "direct to call but ask if lost or stolen",
    directToCallWithDigitalIssuance: "direct to call with digital issuance"
  };

  // "Next" button is clicked.
  const nextBtn = evt => {
    const optionToUse = card.type === "debit" ? debitBranding : creditBranding;
  
    // "Card is stolen" is selected.
    if(reason === "Card is stolen") {
      if(optionToUse === lostStolenOptions.withIssuance) { 
        navigate(`/home/reportloststolen/sentcardtoaddress/${ cardID }`); 
      } else if(optionToUse === lostStolenOptions.directToCallButAsk || optionToUse === lostStolenOptions.directToCallWithDigitalIssuance) {
        navigate(`/home/reportloststolen/turnoffcard/${ cardID }`);
      } else { 
        openModal("LostStolenModal", { route: `/home/reportloststolen/digitalissuanceconfirm/${ cardID }/cardIsStolen` });
      }
    // "Card is lost" is selected.
    } else {
      if(optionToUse === lostStolenOptions.directToCallButAsk || optionToUse === lostStolenOptions.directToCallWithDigitalIssuance) {
        navigate(`/home/reportloststolen/turnoffcard/${ cardID }`);
      } else {
        navigate(`/home/reportloststolen/recognizetransactions/${ cardID }`);
      }
    }
  }

  return (
    <div className="report-view">
      <p className="top-description-text">Your {cardType} card ending in {lastFour} will be disabled once you report it lost or stolen. 
        It can no longer be used for any new purchases. We will send a new card to your address on file. </p>
      <FormContainer>
        <FormRow>
          <p>Reason for reporting card lost or stolen: </p>
        </FormRow>
        <FormRow className="card-stolen-row">
          <UIRadio name="reason" label="Card is stolen" value={reason === "Card is stolen"} onChange={changeReason}/>
        </FormRow>
        <FormRow className="card-lost-row">
          <UIRadio name="reason" label="Card is lost" value={reason === "Card is lost"} onChange={changeReason}/>
        </FormRow>
        {reason === "Card is lost" && <FormRow>
          <UIDatePicker dateLabel="Card Lost Date" allowPast={ true } />
        </FormRow>}
        <FormRow className="flex-container flex-horizontal align-center-container">
          <SVGAsset id="InformationIcon" className="left-inline-icon set-width" />
          <p className="flex-container">If you have misplaced your card, you can turn it OFF while you look for it.</p>
        </FormRow>
        <FormButtonContainer>

          <UIPrimaryButton text="Next" dataPoint="Lost_Stolen_Next" onClick={ nextBtn } />
          <UICancelButton text="Cancel" dataPoint="Lost_Stolen_Cancel" onClick={ evt => navigate(`/home/recenttransactions/${ cardID }`) }/>
        </FormButtonContainer>
      </FormContainer>
    </div>
  );
}